<template>

    <div class="listlayout"  id="rptListBox">

        <el-tabs v-model="activeName" type="card"  @tab-click='tabClick'>
            <el-tab-pane :label="$t('report.myreport')" name="rpt" :key="1">
                <el-tree ref="customTree"    :data="rptList"
                         :element-loading-text="$t('tips_data_loading_in_progress')" :props="nodeProps"
                           node-key="id" highlight-current   @node-click="handleNodeClick">
                </el-tree>
             </el-tab-pane>

            <el-tab-pane  :label="$t('report.args')" name="arg" :key="2">

                <el-form    size="small" label-width="70px">
                    <el-tag  style="margin-top:2Px;margin-bottom:10Px;width:260px;height:30px;font-size: 14px;"> {{ rptInfo.name }}</el-tag>

                    <div v-for="item in  parmObj" >
                        <div v-if="item.type=='text'">
                            <el-form-item  :label=item.title  >
                                <el-input class="parm_item" v-model="item.value" @focus="inputfocus" :placeholder="$t('form_please_enter')"  />
                            </el-form-item>
                        </div>
                        <div v-if="item.type=='select' ">
                            <el-form-item  :label=item.title >

                                <el-select v-model="item.value"  class="parm_item" filterable @focus="selectFocus(item)"  >
                                    <el-option
                                            v-for="item1 in parmData[item.dsname]"
                                            :key="item1.id"
                                            :label="item1.name"
                                            :value="item1.id"

                                    ></el-option>
                                </el-select>

                            </el-form-item>
                        </div>
                        <div v-if="item.type=='date'">
                            <el-form-item :label=item.title  >
                                <el-date-picker  v-model="item.value"  :type="item.datatype" :value-format="item.format"  :format="item.format" size="small" :placeholder="$t('form_date')" style="float:left;width:180px;" >
                                </el-date-picker>
                            </el-form-item>
                        </div>
                        <div v-if="item.type=='tree'">
                            <el-form-item :label=item.title  >

                                <el-select
                                        v-model="item.value"
                                        name="item.name"
                                         :placeholder="$t('form_please_select')"
                                        size="small"
                                        class="parm_item"
                                        :ref="`${item.name}_select`"
                                        filterable
                                        :filter-method="filterOption"
                                        @focus="selectFocus(item)"
                                >
                                    <el-option
                                            :value="item.value"
                                            :label="item.label"
                                            disable
                                            style="height: auto; padding: 0;font-size: 12px;font-family: 'Arial', sans-serif;font-weight: normal;"
                                    >

                              <el-tree   :data="parmTreeData[item.name]" :props="item.props" :ref="`${item.name}_tree`" :filter-node-method="filterTreeNode"
                                         :element-loading-text="$t('tips_data_loading_in_progress')"
                                          node-key="id" highlight-current    @node-click="(data) => treeNodeClick(data, item)">
                                </el-tree>
                                    </el-option>
                                </el-select>


                            </el-form-item>

                        </div>


                    </div>
                    <div style="width:100%;margin:0 auto; text-align: center;line-height:36px;">
                        <el-button type="primary" plain icon="el-icon-search" size="mini" @click="btn('run')">{{$t('report.search')}}</el-button>

                    </div>
                </el-form>

            </el-tab-pane>
        </el-tabs>



    </div>


</template>
<script>
    import { mapGetters } from "vuex";
    import $ from 'jquery';
    import languages from '../lang/languages.js';
    export default {
        name: "getreportList",


        data(){

            return {
                rptType:[],
                rptList:[],
                activeName:"rpt",
                parmData:{},
                parmTreeData:[],
                parmObj:{},
                rptInfo:{},
                currentNode:{},
                nodeProps: { children:false, label: "label", isLeaf: "leaf" },
                focusObj:{},

            }
        },
        watch: {
            rptList: {

                handler(n, o) {
                    this.rptList=n;

                },
                deep:true
            },
        },

        mounted() {
            let lang=sessionStorage.getItem("vc_lang");
            this.$i18n.mergeLocaleMessage(lang, languages[lang]);
            this.rptType=[{id:1,type:'rpt',label:this.$t('report_inventory_report')},
                {id:2,type:this.$t('report_business'),label:this.$t('report_business_report')},
                {id:3,type:this.$t('report_finance'),label:this.$t('report_financial_statements')}];
                this.$emit('loadRptList');
        },
        methods: {
            tabClick(tab,item) {
                  if(this.activeName=="rpt")  this.scrollToNode();
            },


            btn(id) {
                let id_family = id.split("-");
                let sid = id_family[1];
                switch (id_family[0]) {
                    case 'open':
                        this.$refs.pop_tree.showPopper = true;
                        break;
                    case 'run':
                        this.$parent.btn('run');
                        break;
                    default:
                        break;
                }
            },
            setRptList(data){
                this.rptList=data;
            },
            handleNodeClick(e,node,item) {
                this.currentNode=node.data;
                this.$emit('handleNodeClick', node.data);

            },
            treeNodeClick(data,item) {
                item.value=data.id;
                item.label=data.name;
                if (data.hasOwnProperty('type')) item.typeValue=data.type;
                let selectTree=`${item.name}_select`;
                this.$refs[selectTree][0].blur();
            },

            selectRptNode(id){
                this.$nextTick(() => {
                 this.$refs.customTree.setCurrentKey(id); // 设置id为的节点为选中状态
                 this.$emit('handleNodeClick', this.$refs.customTree.getCurrentNode());

                 });
            },
            inputfocus(a){
                a.target.select();
            },
            scrollToNode() {


                this.$nextTick(()=>{    // 获取高亮节点
                    const tree = this.$refs.customTree;
                      let highlightNode = tree.$el.querySelectorAll('.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content');
                         if(highlightNode && highlightNode.length){        highlightNode[0].scrollIntoView(50);
                         }});


            },


            filterOption(value){
              //  if (!value) return true;
                let treename=`${this.focusObj.name}_tree`;
               this.$refs[treename][0].filter(value);
            },
            selectFocus(item){
                      this.focusObj=item;
                 },
            filterTreeNode(value, data) {
                if (!value) return true;
                if (data.name == undefined) {
                    return data.label.indexOf(value) !== -1;
                } else {
                    return data.name.indexOf(value) !== -1 ;
                }
            },


            setParmDetail(item,data,argdata) {
                let _this=this;
                this.parmObj=JSON.parse(JSON.stringify(item.parm));
                this.rptInfo=item.info?item.info:{};
                this.parmData=data;
                this.parmTreeData=[];
                if(argdata){
                    $.each(this.parmObj, function (key, item) {
                        let name=item.name;
                        if(argdata.hasOwnProperty(name))   item.value=argdata[name];
                        let db=item.dsname?item.dsname:item.name;
                        let db2=item.dschild?_this.parmData[item.dschild]:null;
                        if(item.type=="tree" ) {
                            _this.parmTreeData[name] =_this.setTreeItem(_this.parmData[db],db2);

                        }
                    });}
                this.parmObj.initParm=1;
               // this.activeName="arg";
            },
            setTreeItem(data,data1){
                let _this=this;
                let newdata=[];
                $.each(data, function (key, item) {
                    if (data.filter(obj => obj.id==item.pid).length==0)
                    {  item['children']=[];
                        item=_this.setTreeChild(item,data,data1);
                        newdata.push(item);}
                });
                return newdata;
            },
            setTreeChild(p,data,data1){
                let _this=this;
                let childItem=data.filter(obj => obj.pid==p.id)
                if (childItem.length==0 && data1!=null) p=this.setTreeChild2(p,data1);
                $.each(childItem, function (key, item) {
                    item['children']=[];
                    item=_this.setTreeChild(item,data,data1);
                    p.children.push(item);
                });
                return p;
            },
            setTreeChild2(p,data1){
                let _this=this;
                let childItem=data1.filter(obj => obj.pid==p.id)
                $.each(childItem, function (key, item) {
                    item['children']=[];
                    p.children.push(item);
                });
                return p;
            },
            getArgsObj()
            {
                let _this=this;
                let args={};
                $.each(_this.parmObj, function (key, data) {
                    let db=data.dsname?data.dsname:data.name;
                    if(data.type=="select" && _this.parmData[db])
                    {
                        let op =_this.parmData[db].filter((item)=>{
                            return item.id=== data.value
                        })
                        args[data.name]=op.length>0?op[0].id:data.value;
                        args[data.name+"_t"]=op.length>0?op[0].name:"";
                    }
                    if(data.type=="tree" && _this.parmData[db])
                    {

                        args[data.name]=data.value;
                        args[data.name+"_t"]=data.label;
                        if (data.hasOwnProperty("typeValue")) args[data.name+"_type"]=data.typeValue;
                    }
                    else if(data.type=="date" )
                    {
                        if(data.value==null|| data.value==undefined ) data.value=new Date();

                        args[data.name]=data.value;
                        //java 后台shezhi data.name+"_s|_e"
                        if ( data.datatype=='month')
                        {

                            args[data.name+"_s"]=data.value+"-01";
                            var d=data.value.split("-");
                            var lastDay= new Date(d[0],d[1],0).getDate();
                            args[data.name+"_e"]=data.value+"-"+lastDay;
                        } else {
                            let nd=new Date(data.value);
                            const year =nd.getFullYear();
                            const month = String(nd.getMonth() + 1).padStart(2, '0'); // 月份补0，使其始终为两位数
                            args[data.name+"_s"]= `${year}-${month}-01`;
                            let lastDay= nd.getDate();
                            args[data.name+"_e"]=`${year}-${month}-${lastDay}`;

                        }
                    }
                    else
                        args[data.name]=data.value;
                });
                args.initParm=1;
                return args;
            },



        }
    };


</script>

<style lang="scss" >


    .listlayout {
        height: 100%;
        width: 260px;
            /*flex: 1;*/
            position: relative;
             overflow: hidden;
        .el-tabs {
            width: 260px;
            height: calc(100%);
            border: 0px solid #267b87;
            .el-tabs__header {
                /*height: 36px;*/
                margin: 0;
                padding: 0px;
            }
            .el-tabs-card {
                margin: 0;
                padding: 0;
                width: 100%;
                height: 34px;


            }

       }
            .el-tabs__item.is-active {
                color: #774917;
                background-color: #a9e0ea; //修改背景色
            }

            .el-tabs__content {
                margin: 0;
                padding: 0px;
                border: 0px solid #267b87;
                height: calc(100% - 36px);
                overflow: auto;
            }

        .parm_item
            {   padding: 0px 0px;
                margin: 0px;
                height: 32px;
                position: relative;
                float: left;
                width: 180px;
            }

    }
</style>
